/**
 * FICHIER GÉNÉRÉ — ne pas modifier à la main.
 *
 * Produit par `npm run measure:assets`. Emprise opaque de chaque asset rendu, en
 * pixels : [largeur, hauteur]. Un MODÈLE par entrée : les quatre orientations d'un même
 * modèle partagent son échelle par construction, les variantes sont des modèles à part.
 *
 * Règle 15 : une table dérivée d'une mesure ne s'écrit jamais à la main. Cette table est
 * la MESURE ; les proportions voulues sont déclarées dans `assetScale.ts`.
 */

export const ASSET_OPAQUE_SIZE: Readonly<Record<string, readonly [number, number]>> = {
  bench: [467, 494],
  bin: [346, 619],
  bush1: [318, 262],
  'car-1': [415, 375],
  'car-2': [397, 289],
  'car-3': [443, 418],
  'car-4': [444, 384],
  'cinema-t1': [560, 879],
  'cinema-t2': [574, 843],
  'cinema-t3': [567, 779],
  'cottage-t1': [430, 324],
  'cottage-t1-v1': [434, 318],
  'cottage-t1-v2': [455, 287],
  'cottage-t2': [379, 369],
  'cottage-t2-v1': [392, 313],
  'cottage-t2-v2': [424, 374],
  'cottage-t3': [421, 357],
  'cottage-t3-v1': [359, 335],
  'cottage-t3-v2': [413, 302],
  'doctor-t1': [626, 1098],
  'doctor-t2': [536, 967],
  'doctor-t3': [616, 602],
  'fishShop-t1': [864, 641],
  'fishShop-t2': [916, 632],
  'fishShop-t3': [787, 838],
  flowerbed: [472, 405],
  fountain: [346, 257],
  'grocery-t1': [838, 620],
  'grocery-t2': [938, 547],
  'grocery-t3': [680, 532],
  'helipad-t1': [472, 287],
  'house-t1': [359, 335],
  'house-t1-v1': [430, 324],
  'house-t1-v2': [455, 287],
  'house-t2': [413, 302],
  'house-t2-v1': [458, 316],
  'house-t2-v2': [443, 372],
  'house-t3': [421, 357],
  'house-t3-v1': [424, 374],
  'house-t3-v2': [434, 318],
  'playground-t1': [356, 305],
  'poolClub-t1': [322, 242],
  potplants: [462, 372],
  'restaurant-t1': [594, 989],
  'restaurant-t2': [837, 1122],
  'restaurant-t3': [452, 379],
  'road-corner': [539, 332],
  'road-cross': [539, 331],
  'road-end': [539, 331],
  'road-straight': [539, 329],
  'road-t': [539, 329],
  rock1: [264, 261],
  rock2: [383, 213],
  'school-t1': [726, 739],
  'school-t2': [545, 773],
  'school-t3': [840, 671],
  stopSign: [231, 705],
  streetLight: [297, 671],
  'streetStand-t1': [415, 372],
  'streetStand-t1-v1': [260, 323],
  'streetStand-t2': [260, 323],
  'streetStand-t2-v1': [415, 372],
  'streetStand-t3': [470, 367],
  'streetStand-t3-v1': [260, 323],
  'tile-column': [539, 2068],
  'tile-concrete': [539, 331],
  'tile-grass': [539, 332],
  'tile-grass-2': [539, 332],
  'tile-island': [536, 342],
  trafficLight: [248, 751],
  tree1: [346, 616],
  tree2: [334, 559],
  tree3: [348, 634],
  'waterTower-t1': [214, 378],
  'workplace-t1': [642, 1083],
  'workplace-t2': [672, 831],
  'workplace-t3': [856, 915],
};
